'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _IDate = require('../../../common/iObjects/IDate');

var _IDate2 = _interopRequireDefault(_IDate);

var _IPeriod = require('../../../common/iObjects/IPeriod');

var _IPeriod2 = _interopRequireDefault(_IPeriod);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;

        _this.submit = function () {
            if (typeof _this.props.onSubmit === 'function' && _this._selectedStartStamp !== null) {
                _this.props.onSubmit(_this.value);
            }

            return _this;
        };

        _this.cancel = function () {
            if (typeof _this.props.onCancel === 'function') {
                _this.props.onCancel();
            }

            return _this;
        };

        _this._isDateInPeriod = function (date) {
            if (_this.props.isPeriod) {
                date = date instanceof _IDate2.default ? date : new _IDate2.default(date);
                var dateStamp = date.getTime();

                return dateStamp >= _this._selectedStartStamp && dateStamp <= _this._selectedEndStamp;
            } else {
                return false;
            }
        };

        _this._isStartOfPeriod = function (date) {
            date = date instanceof _IDate2.default ? date : new _IDate2.default(date);
            var dateStamp = date.getTime();

            return dateStamp === _this._selectedStartStamp;
        };

        _this._isEndOfPeriod = function (date) {
            date = date instanceof _IDate2.default ? date : new _IDate2.default(date);
            var dateStamp = date.getTime();

            return dateStamp === _this._selectedEndStamp;
        };

        _this._isOneDayPeriod = function () {
            return _this._selectedStartStamp === _this._selectedEndStamp;
        };

        _this._isTodaySelected = function (date) {
            date = date instanceof _IDate2.default ? date : new _IDate2.default(date);
            var dateStamp = date.getTime();

            return dateStamp === _this._todayDateStamp;
        };

        _this._isForbiddenDate = function (date) {
            date = date instanceof _IDate2.default ? date : new _IDate2.default(date);

            var dateStamp = date.getTime(),
                _this$props = _this.props,
                isPeriod = _this$props.isPeriod,
                allowedMonths = _this$props.allowedMonths,
                month = date.get('month'),
                dateString = date.toString('dd.mm.yyyy');


            return (
                // запрещенный месяц
                !isPeriod && allowedMonths && allowedMonths.length && allowedMonths.indexOf(month) < 0 ||
                // запрещенный день календаря
                !isPeriod && _this.allowedDates instanceof Array && _this.allowedDates.length && _this.allowedDates.indexOf(dateString) < 0 ||
                // запрещенный период дат
                _this.allowedDates instanceof _IPeriod2.default && (_this._allowedDatesStart > dateStamp || _this._allowedDatesEnd < dateStamp) ||
                // запрещенный день календаря (реверс)
                !isPeriod && _this.deniedDates instanceof Array && _this.deniedDates.length && _this.deniedDates.indexOf(dateString) >= 0 || _this.deniedDates instanceof _IPeriod2.default && dateStamp >= _this._deniedDatesStart && dateStamp <= _this._deniedDatesEnd
            );
        };

        _this.state = {};

        var value = _this.getValue(),
            currentDate = void 0,
            today = new _IDate2.default('today').set({ date: 1, minutes: 0, hours: 0, seconds: 0, ms: 0 });

        // current monthpicker date;
        currentDate = value ? _this.props.isPeriod ? value.get('end') : value : today;
        currentDate = currentDate.get('year') > _this.props.maxYear || currentDate.get('year') < _this.props.minYear ? today : currentDate;

        _this.state.value = value;
        _this.state.currentDate = currentDate;

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._prepareData();
            return this;
        }
    }, {
        key: 'componentWillReceiveProps',


        /**
         * при изменении значения в модели / вызывающем коде
         * нужно обновить значение в состоянии
         * @param {object} nextProps
         * @return {object}
         */
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                this.setState({ value: this.getValue() });
            }

            return this;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this._prepareData(nextProps, nextState);
            return this;
        }

        /**
         * подготавливает данные для внутренних расчетов
         * @param {object} props
         * @param {object} state
         * @return {object}
         * @private
         */

    }, {
        key: '_prepareData',
        value: function _prepareData() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

            this.allowedDates = props.allowedDates instanceof Array ? props.allowedDates : new _IPeriod2.default(props.allowedDates);
            // timestamps for allowed dates period (IPeriod)
            this._allowedDatesStart = this.allowedDates instanceof _IPeriod2.default && this.allowedDates.validate() ? this.allowedDates.get('start').set({
                date: 1,
                minutes: 0,
                hours: 0,
                seconds: 0,
                ms: 0
            }).getTime() : null;

            this._allowedDatesEnd = this.allowedDates instanceof _IPeriod2.default && this.allowedDates.validate() ? this.allowedDates.get('end').set({
                date: 1,
                minutes: 0,
                hours: 0,
                seconds: 0,
                ms: 0
            }).getTime() : null;

            this.deniedDates = props.deniedDates instanceof Array ? props.deniedDates : new _IPeriod2.default(props.deniedDates);
            // timestamps for allowed dates period (IPeriod)
            this._deniedDatesStart = this.deniedDates instanceof _IPeriod2.default && this.deniedDates.validate() ? this.deniedDates.get('start').set({
                date: 1,
                minutes: 0,
                hours: 0,
                seconds: 0,
                ms: 0
            }).getTime() : null;

            this._deniedDatesEnd = this.deniedDates instanceof _IPeriod2.default && this.deniedDates.validate() ? this.deniedDates.get('end').set({
                date: 1,
                minutes: 0,
                hours: 0,
                seconds: 0,
                ms: 0
            }).getTime() : null;

            this._monthCount = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
            this._todayDateStamp = new _IDate2.default('today').getTime();

            if (state.value) {
                this.startDate = props.isPeriod ? new _IDate2.default(state.value.get('start').toString('dd.mm.yyyy')) : new _IDate2.default(state.value.toString('dd.mm.yyyy'));
                this.endDate = props.isPeriod ? new _IDate2.default(state.value.get('end').toString('dd.mm.yyyy')) : null;

                // make timestamps of selected date
                this._selectedStartStamp = this.startDate && this.startDate.getTime();
                this._selectedEndStamp = this.endDate && this.endDate.getTime();
            }

            /* technical data */
            this._currMonth = state.currentDate.toString('mm');
            this._currYear = state.currentDate.get('year');

            return this;
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.value;

            // set first day of month
            if (value) {
                value = this.props.isPeriod ? new _IPeriod2.default(value) : new _IDate2.default(value);
                if (this.props.isPeriod) {
                    value.set({ start: value.get('start').set({ date: 1, minutes: 0, hours: 0, seconds: 0, ms: 0 }) });
                    value.set({ end: value.get('end').set({ date: 1, minutes: 0, hours: 0, seconds: 0, ms: 0 }) });
                } else {
                    value.set({ date: 1, minutes: 0, hours: 0, seconds: 0, ms: 0 });
                }
            }

            if (value && !value.validate()) {
                value = null;
            }

            return value;
        }
    }, {
        key: '_shift',
        value: function _shift() {
            var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var nextDate = void 0,
                shift = {},
                attr = 'year',

            // copy
            current = new _IDate2.default(this.state.currentDate);

            shift[attr] = dir;
            // reset day to 1
            current.set({ date: 1 });
            nextDate = current.getShifted(shift);

            if (nextDate.get('year') >= this.props.minYear && nextDate.get('year') <= this.props.maxYear) {
                this.setState({ currentDate: nextDate });
            }

            return this;
        }
    }, {
        key: 'select',
        value: function select(date) {
            if (!date) return this;

            date = date instanceof _IDate2.default ? date : new _IDate2.default(date);

            if (this.props.isPeriod) {
                this._selectPeriod(date);
            } else {
                this._selectDate(date);
            }
        }
    }, {
        key: '_selectDate',
        value: function _selectDate(value) {
            var _this2 = this;

            if (!this._isForbiddenDate(value)) {
                this.setState({ value: value }).then(function () {
                    if (typeof _this2.props.onSubmit === 'function') {
                        _this2.props.onSubmit(_this2.value);
                    }
                });
            }
        }
    }, {
        key: '_selectPeriod',
        value: function _selectPeriod(date) {
            date.set({ hours: 0, minutes: 0 });

            var value = this.state.value;

            if (this._isForbiddenDate(date)) {
                return;
            }

            // период уже выбран
            if (this._selectionStart && this._selectionEnd) {
                // сбрасываем период
                value = new _IPeriod2.default(date, date);
                this._selectionStart = true;
                this._selectionEnd = false;

                // выбрана начальная дата
            } else if (this._selectionStart && !this._selectionEnd) {
                value = new _IPeriod2.default(value.get('start'), date);
                this._selectionEnd = true;

                // не выбрано ничего
            } else if (!this._selectionStart && !this._selectionEnd) {
                value = new _IPeriod2.default(date, date);
                this._selectionStart = true;
            }

            this.setState({ value: value });
            return this;
        }
    }, {
        key: 'value',
        get: function get() {
            if (typeof this.props.stringify === 'function') {
                return this.props.stringify(this.state.value);
            } else {
                return this.state.value;
            }
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    minYear: 1970,
    maxYear: 2050,
    yearChange: false,
    // [01, 02, 03 ...]
    allowedMonths: [],
    // ['01.01.2015', ... '']
    deniedDates: [],
    // ['01.01.2015', ... ''] || IPeriod || '01.02.2015-01.02.2016'
    allowedDates: [],
    // period selection
    isPeriod: false,
    // components default value
    value: null,
    onSubmit: null,
    onCancel: null
};
Main.propTypes = {
    deniedDates: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    allowedDates: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    isPeriod: _propTypes2.default.bool,
    allowedMonths: _propTypes2.default.array,
    minYear: _propTypes2.default.number,
    maxYear: _propTypes2.default.number,
    yearChange: _propTypes2.default.bool,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
};
Main.displayName = 'MonthPicker';
exports.default = Main;